import { MetricConverter } from './helpers';

const PowerUnits = ['kW', 'MW', 'W'] as const;
export type TPowerUnit = (typeof PowerUnits)[number];

class PowerConverter extends MetricConverter<TPowerUnit, 'W'> {
    baseUnit = 'W' as const;
    units = PowerUnits;
    protected unitSwitchThreshold = 1000;
}

export const powerConverter = new PowerConverter();
